import { render, staticRenderFns } from "./sousuo.vue?vue&type=template&id=4c27d9d3&"
import script from "./sousuo.vue?vue&type=script&lang=js&"
export * from "./sousuo.vue?vue&type=script&lang=js&"
import style0 from "./sousuo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports